import React from 'react';
import {
    CmsPageContentType,
    CmsRouterContentIdentifier,
    ExternalHardwareType,
    HardwareOptionType,
    OwnHardwareType
} from "@/types/fitting-hardware";

type OwnRouterComponentProps = {
    routeHeader: string;
    checked: boolean;
    onClick: VoidFunction | undefined;
    selectedHardwareOption: HardwareOptionType | undefined;
    learnMore: string;
    cmsContent: CmsPageContentType
    accessType: string
};
function disableSelectionButton(selectedHardwareOption: OwnHardwareType | ExternalHardwareType | undefined, checked: boolean) {
    if (selectedHardwareOption === undefined) {
        return false;
    }
    return !checked;
}

const OwnRouterComponent: React.FunctionComponent<OwnRouterComponentProps> = ({
                                                                                  routeHeader,
                                                                                  checked = false,
                                                                                  onClick,
                                                                                  learnMore,
                                                                                  selectedHardwareOption,
                                                                                  cmsContent,
                                                                                  accessType
                                                                              }) => {
    const style = `
    .selected-Router-button{
    background: #fff !important;
    color: #0019a5 !important;
    }
    .selected-Router-button:hover{
    color: #fff !important;
    background: #0019a5 !important;
    }
     @media only screen and (min-width: 768px) {
  .own-router-tile {
  display: flex;
  }
  
  @media only screen and (min-width: 767px) {
  .own-router-details {
  margin-top: 16 px
  }
  }
    `;
    const routerInfoHeader : string | any = () => {
        switch (accessType) {
            case 'DTAG-FTTH-ETH':
            case 'UGG-FTTH-ETH':
                return CmsRouterContentIdentifier.OwnRouterInfoHeaderTextFtth;
            case 'FMS4G':
            case 'FMS5G':
                return CmsRouterContentIdentifier.OwnRouterInfoHeaderTextFms;
            case 'COAX':
                return CmsRouterContentIdentifier.OwnRouterInfoHeaderTextCable;
            default:
                return CmsRouterContentIdentifier.OwnRouterInfoHeaderTextDsl;
        }
    }
    const routerDescriptionText : string | any = () => {
        switch (accessType) {
            case 'DTAG-FTTH-ETH':
            case 'UGG-FTTH-ETH':
                return CmsRouterContentIdentifier.OwnRouterDescriptionTextFtth;
            case 'FMS4G':
            case 'FMS5G':
                return CmsRouterContentIdentifier.OwnRouterDescriptionTextFms;
            case 'COAX':
                return CmsRouterContentIdentifier.OwnRouterDescriptionTextCable;
            default:
                return CmsRouterContentIdentifier.OwnRouterDescriptionTextDsl;
        }
    }
    return (
        <>
            <style>{style}</style>
            {
                accessType === 'DTAG-FTTH-ETH' &&
                <h1 className="router-section-header" dangerouslySetInnerHTML={{ __html: routeHeader }} />
            }
            <div className={checked ? 'hardware-tile-checked' : 'hardware-tile'}>
                <div className="row own-router-tile" style={{ margin:'0px'}}>
                    <div className="col-sm-9 router-tile-section">
                        <div className="device-name">
                            <strong
                                dangerouslySetInnerHTML={{__html: cmsContent[routerInfoHeader()]}}/>
                        </div>
                        <span className="router-short-description" dangerouslySetInnerHTML={{ __html: cmsContent[routerDescriptionText()]}}/>
                        <div className="product-details own-router-details"
                             dangerouslySetInnerHTML={{ __html: learnMore }} />
                    </div>
                    <div className="col-sm-3 router-tile-section" style={{display:"flex",
                        justifyContent: "end", alignItems:"end"}}>
                        <button
                            className={checked ? "btn btn-plain select-Router-button selected-Router-button" : "btn btn-plain select-Router-button"}
                            onClick={onClick}
                            disabled={disableSelectionButton(selectedHardwareOption, checked)}
                            dangerouslySetInnerHTML={{__html: checked ? 'Entfernen' : 'Auswählen'}}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default OwnRouterComponent;
